// extracted by mini-css-extract-plugin
export default {"wrapper":"PageContainer_wrapper__LIcam"};